export default __webpack_public_path__ + "136de92.png";